<template>
  <div>
    <b-card title="Discount List">
      <b-col cols="12">
        <b-row class="mb-2">
          <b-col cols="4">
            <b-button v-if="permission.add" @click="goToAddDiscount" variant="success">
              Add Discount
            </b-button>
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="4">
            <b-form-input
              v-model="search"
              type="search"
              placeholder="Type to Search"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table
              :fields="fields"
              :filter="search"
              :current-page="currentPage"
              :per-page="perPage"
              :items="discounts"
              show-empty
            >
              <template #cell(actions)="row">
                <b-dropdown
                  id="dropdown-dropleft"
                  variant="primary"
                  size="sm"
                  text="Menu"
                  no-caret
                >
                  <template #button-content>
                    <feather-icon size="1x" icon="MenuIcon" />
                  </template>
                  <b-dropdown-item
                    style="text-align:center"
                    v-if="permission.edit"
                  >
                    <b-button
                      variant="outline-primary"
                      @click="goToEditDiscount(row.item.id)"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-dropdown-item>
                  <b-dropdown-item
                    style="text-align:center"
                    v-if="permission.delete"
                  >
                    <b-button variant="danger" @click="deleteDiscount(row.item)">
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
          <b-col cols="12">
            <b-pagination
              :total-rows="discounts.length"
              :per-page="perPage"
              v-model="currentPage"
              style="float: right"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-card>
    <b-modal 
      v-model="deleteModal"
      title="Delete Discount"
      @ok="handleDeleteDiscount"
    >
      Are you sure you want to delete ?
    </b-modal>

  </div>
</template>

<script>
import { mapActions,mapState } from "vuex";
import { userAccess } from "@/utils/utils";
import { dateFormat } from "@/utils/utils";

export default {
  data() {
    return {
      fields: [
        { key: "value", label: "Value(%)", filterable: true, sortable: true },
        { key: "status", label: "Status", filterable: true, sortable: true },
        { key: "actions", label: "Action" },
      ],
      search: "",
      currentPage: 1,
      perPage: 10,
      deleteModal: false,
      deleteRow: null
    };
  },
  mounted() {
    this.$store.dispatch("discount/fetchDiscount");
  },
  methods: {
    goToAddDiscount() {
      this.$router.push("/settings/discount-add");
    },
    goToEditDiscount(id) {
      this.$router.push(`/settings/discount-edit/${id}`);
    },
    deleteDiscount(obj) {
      this.deleteModal = true
      this.deleteRow = obj
    },
    handleDeleteDiscount() {
      if (this.deleteRow.status === "Active") {
        this.$bvToast.toast('Cannot delete active discount', {
          title: "Error",
          variant: "warning",
          solid: true,
        });
        return
      }

      this.$store
        .dispatch("discount/deleteDiscount", this.deleteRow.id)
        .then((res) => {
          this.$bvToast.toast('Delete discount success', {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.deleteModal = false
          this.deleteRow = null
          this.$store.dispatch("discount/fetchDiscount");
        }).catch((err) => {
          console.log(err)
          this.$bvToast.toast('Delete discount fail', {
            title: "Error",
            variant: "warning",
            solid: true,
          });
        })
    }
  },
  computed: {
    permission() {
      return userAccess("Discount", "settings_menu");
    },
    discounts() {
      return this.$store.getters["discount/getDiscount"];
    }
  },
  created() {
    document.title = "Discount | RSP";
  },
};
</script>
